import type { FC, ReactElement } from 'react';
import React from 'react';
import { MDText } from 'i18n-react';

import { ChevronDownIcon, ChevronUpIcon, CrossIcon } from '@motorway/mw-highway-code';
import { Chip } from '@motorway/mw-highway-code/pre-alpha';

import texts from '../../VehicleListV2.texts.json';
import type { AnchorCSSProperties } from '../FilterBarV2.types';
import { useFilterPopover } from '../hooks/useFilterPopover';

import styles from './FilterChip.module.scss';

const LocalT = new MDText(texts.filterBar);

interface FilterChipChildrenProps {
	onClose: () => void;
	resetKey: number;
}

interface FilterChipProps {
	activeLabel?: string;
	children: (props: FilterChipChildrenProps) => ReactElement;
	id: string;
	isActive?: boolean;
	label: string;
}

export const FilterChip: FC<FilterChipProps> = ({ activeLabel, children, id, isActive, label }) => {
	const { anchorName, chipWrapperRef, close, draftVersion, isOpen, popoverId, popoverRef } = useFilterPopover({ id });

	return (
		<div ref={chipWrapperRef} className={styles.chipWrapper} style={{ anchorName } as AnchorCSSProperties}>
			<Chip
				data-testid={`filter-chip-${id}`}
				icon={isOpen ? ChevronUpIcon : ChevronDownIcon}
				label={activeLabel || label}
				selected={isActive || isOpen}
				size="medium"
			/>
			<div
				ref={popoverRef}
				className={styles.popoverDropdown}
				id={popoverId}
				popover="auto"
				style={{ positionAnchor: anchorName } as AnchorCSSProperties}
			>
				<button
					aria-label={`${LocalT.translate('closeFilter')}`}
					className={styles.closeButton}
					data-testid={`filter-chip-close-${id}`}
					onClick={() => close()}
					type="button"
				>
					<CrossIcon />
				</button>
				{children({ onClose: close, resetKey: draftVersion })}
			</div>
		</div>
	);
};
